import { Tooltip, TooltipPosition } from '@tableau/widgets';
import * as React from 'react';
import { style } from 'typestyle';
import { Messages } from '../gen-src/Localize';
import { SvgIcon, SvgIconName } from './resources/SvgIcon';

export const MetricSnapshotBadge = (props: { tooltipText?: string }): JSX.Element => {
  const getTooltipContent = () => <span>{props.tooltipText}</span>;

  const snapshotBadge = (
    <div data-tb-test-id="metric-snapshot-badge" className={badgeStyle}>
      <SvgIcon name={SvgIconName.CAMERA} color={BADGE_COLOR} altText={''} />
      <div style={textStyle}>{Messages.Snapshot()}</div>
    </div>
  );

  return props.tooltipText ? (
    <Tooltip getContent={getTooltipContent} position={TooltipPosition.Bottom}>
      {snapshotBadge}
    </Tooltip>
  ) : (
    snapshotBadge
  );
};

const BADGE_COLOR = '#1277BA';

const badgeStyle = style({
  display: 'inline-flex',
  border: `1px solid ${BADGE_COLOR}`,
  padding: '0 8px 1px 8px',
  alignItems: 'center',

  $nest: {
    '&:focus, &:focus-visible': {
      boxShadow: '0 0 4px 0 #3498db',
      outline: 'none',
    },
  },
});

const textStyle: React.CSSProperties = {
  color: BADGE_COLOR,
  fontSize: '12px',
  float: 'right',
  padding: '2px 0 0 2px',
  lineHeight: 'normal',
};
